<div class="agpr-formField">
    <div
        *ngIf="field.label"
        class="agpr-formField-label agpr-colorCheckboxesContainer-heading"
    >
        {{ field.label | localize }}
    </div>
    <ng-container *ngFor="let series of value; let i = index">
        <div
            class="agpr-colorCheckboxesContainer"
        >
            <div
                *ngIf="series.label"
                class="agpr-formField-label"
            >
                {{ series.label | localize }}
            </div>
            <div class="agpr-colorCheckboxesContainer-colorPickerFieldContainer">
                <agpr-color-picker-field
                    [id]="id + '.colorPickerField_' + i"
                    [value]="series.color"
                    (changes)="handleColorChange($event, i)"
                ></agpr-color-picker-field>
            </div>
        </div>
    </ng-container>
    <div
        *ngIf="field.description"
        class="agpr-formField-description"
    >
        {{ field.description | localize }}
    </div>
</div>
